import { render, staticRenderFns } from "./artificialChat.vue?vue&type=template&id=6f670280"
import script from "./artificialChat.vue?vue&type=script&lang=js"
export * from "./artificialChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports